<template> 
  <div
    class="root tw-py-2.5 tw-px-2 tw-flex tw-flex-row tw-items-center tw-justify-center"
    :class="`tw-flex-${orientationMapped} tw-w-${width} tw-h-${height}`"
  >
    
    <div class="hub-card-content" :class="isGameCard ? 'hub-games-card-content' : ''">
      <div
          class="graphic"
          :class="isGameCard ? 'hub-games-garphic' : ''"
        >
          <slot name="graphic" />
        </div>
        <div class="hub-card-content-col" :class="isGameCard ? 'align-left-content' : 'align-center-content'">
          <p class="card-main-title" >{{ title }}</p>
          <p class="tw-block hub-content-description" :class="$i18n.locale === 'ar' ? 'arabic-text arabic-text-right' : ''">{{ description }}</p>
          <div class="actions-slot">
            <slot name="actions" />
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppCard",
  props: {
    isGameCard: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    graphicBgColor: {
      type: Object,
      default: undefined,
    },
    orientation: {
      type: String,
      default: "vertical",
    },
  },
  computed: {
    orientationMapped() {
      const orientationMapping = {
        vertical: "col",
        horizontal: "row",
      };

      return orientationMapping[this.orientation];
    },
    graphicBgGradient() {
      if (!this.graphicBgColor) {
        return undefined;
      }

      const { from, via, to } = this.graphicBgColor;

      return `tw-bg-gradient-to-b tw-from-${from} tw-via-${via} tw-to-${to}`;
    },
    width() {
      return this.orientationMapped === "row" ? "307px" : "150px";
    },
    height() {
      return this.orientationMapped === "row" ? "139px" : "234px";
    },
    contentAlignment() {
      return this.orientationMapped === "row" ? "tw-items-start" : undefined;
    },
    textAlignment() {
      return this.orientationMapped === "row" ? "tw-text-left" : undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  // background-color: rgba(41, 182, 246, 0.2);
  // border-radius: 10px;
  font-family: "Nunito-Regular";
}
.hub-card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding-block: 10px;
  margin: 10px;
}
.hub-games-card-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.hub-games-garphic {
  padding-right: 10px;
}
.hub-card-content-col {
  display: flex;
  flex-direction: column;
  
  &.align-center-content {
    align-items: center;
    justify-content: center;
  }
  &.align-left-content {
    text-align: left;
    justify-content: left; 
  }
}
.card-main-title {
  font-family: "Nunito-ExtraBold";
  color: #020076;
  font-size: 1.0.7rem;
}
.hub-content-description {
  font-family: "Nunito-Regular";
  font-size: 0.6rem;
  color: #020076;
  max-width: 90%;
}
.actions-slot {
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-block: 5px;
}
.arabic-text-right {
  text-align: right;
}
.graphic {
  margin: 5px;
  img {
    // transform: scale(1.5);
  }
}
</style>
